import {
  DataTableFilterMeta,
  DataTableFilterMetaData,
} from "primevue/datatable";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { ref } from "vue";

export default function tabelaTiposDeAtividade() {
  const filtrosTabelaSelecionarTiposDeAtividade = ref<DataTableFilterMeta>({
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    profissionalNecessario: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
  })

  return {
    filtrosTabelaSelecionarTiposDeAtividade
  }
}
